const SCOPE = {
  // [FILE]
  create_file: 'CREATE_ANY_FILE',

  // [ROLES]
  // - platform
  get_pla_role: 'GET_ANY_PLATFORM_ROLE',
  create_pla_role: 'CREATE_ANY_PLATFORM_ROLE',
  update_pla_role: 'UPDATE_ANY_PLATFORM_ROLE',
  get_est_role: 'GET_ANY_ESTABLISHMENT_ROLE',

  // - establishment (own)
  get_ownEst_role: 'GET_ANY_ESTABLISHMENT_ROLE_OF_OWN_ESTABLISHMENT',
  create_ownEst_role: 'CREATE_ANY_ESTABLISHMENT_ROLE_OF_OWN_ESTABLISHMENT',
  update_ownEst_role: 'UPDATE_ANY_ESTABLISHMENT_ROLE_OF_OWN_ESTABLISHMENT',

  // [ADMIN ACCOUNTS]
  // - platform
  get_pla_adminAccount: 'GET_ANY_PLATFORM_ADMIN_ACCOUNT',
  create_pla_adminAccount: 'CREATE_ANY_PLATFORM_ADMIN_ACCOUNT',
  update_pla_adminAccount: 'UPDATE_ANY_PLATFORM_ADMIN_ACCOUNT',
  activate_pla_adminAccount: 'ACTIVATE_ANY_PLATFORM_ADMIN_ACCOUNT',
  deactivate_pla_adminAccount: 'DEACTIVATE_ANY_PLATFORM_ADMIN_ACCOUNT',
  get_est_adminAccount: 'GET_ANY_ESTABLISHMENT_ADMIN_ACCOUNT',
  create_est_adminAccount: 'CREATE_ANY_ESTABLISHMENT_ADMIN_ACCOUNT',

  // - establishment (own)
  get_ownEst_adminAccount: 'GET_ANY_ESTABLISHMENT_ADMIN_ACCOUNT_OF_OWN_ESTABLISHMENT',
  create_ownEst_adminAccount: 'CREATE_ANY_ESTABLISHMENT_ADMIN_ACCOUNT_OF_OWN_ESTABLISHMENT',
  update_ownEst_adminAccount: 'UPDATE_ANY_ESTABLISHMENT_ADMIN_ACCOUNT_OF_OWN_ESTABLISHMENT',
  activate_ownEst_adminAccount: 'ACTIVATE_ANY_ESTABLISHMENT_ADMIN_ACCOUNT_OF_OWN_ESTABLISHMENT',
  deactivate_ownEst_adminAccount: 'DEACTIVATE_ANY_ESTABLISHMENT_ADMIN_ACCOUNT_OF_OWN_ESTABLISHMENT',

  // [ESTABLISHMENTS]
  // - platform
  get_pla_establishment: 'GET_ANY_ESTABLISHMENT',
  create_pla_establishment: 'CREATE_ANY_ESTABLISHMENT',
  update_pla_establishment: 'UPDATE_ANY_ESTABLISHMENT',
  activate_pla_establishment: 'ACTIVATE_ANY_ESTABLISHMENT',
  deactivate_pla_establishment: 'DEACTIVATE_ANY_ESTABLISHMENT',

  // [MEDIAS]
  // - platform
  get_pla_media: 'GET_ANY_PLATFORM_MEDIA',
  create_pla_media: 'CREATE_ANY_PLATFORM_MEDIA',
  update_pla_media: 'UPDATE_ANY_PLATFORM_MEDIA',
  delete_pla_media: 'ARCHIVE_ANY_PLATFORM_MEDIA',

  // - establishment (own)
  get_ownEst_media: 'GET_ANY_ESTABLISHMENT_MEDIA_OF_OWN_ESTABLISHMENT',
  create_ownEst_media: 'CREATE_ANY_ESTABLISHMENT_MEDIA_OF_OWN_ESTABLISHMENT',
  update_ownEst_media: 'UPDATE_ANY_ESTABLISHMENT_MEDIA_OF_OWN_ESTABLISHMENT',
  delete_ownEst_media: 'ARCHIVE_ANY_ESTABLISHMENT_MEDIA_OF_OWN_ESTABLISHMENT',

  // [CAMPS]
  // - establishment (own)
  get_ownEst_camp: 'GET_ANY_CAMP_OF_OWN_ESTABLISHMENT',
  create_ownEst_camp: 'CREATE_ANY_CAMP_OF_OWN_ESTABLISHMENT',
  update_ownEst_camp: 'UPDATE_ANY_CAMP_OF_OWN_ESTABLISHMENT',

  // [EXTRAS]
  // - establishment (own)
  get_ownEst_extra: 'GET_ANY_EXTRA_OF_OWN_ESTABLISHMENT',
  create_ownEst_extra: 'CREATE_ANY_EXTRA_OF_OWN_ESTABLISHMENT',
  update_ownEst_extra: 'UPDATE_ANY_EXTRA_OF_OWN_ESTABLISHMENT',

  // [ACCOMMODATIONS]
  // - establishment (own)
  get_ownEst_accommodation: 'GET_ANY_ACCOMMODATION_OF_OWN_ESTABLISHMENT',
  create_ownEst_accommodation: 'CREATE_ANY_ACCOMMODATION_OF_OWN_ESTABLISHMENT',
  update_ownEst_accommodation: 'UPDATE_ANY_ACCOMMODATION_OF_OWN_ESTABLISHMENT',

  // [PACKAGES]
  // - establishment (own)
  get_ownEst_package: 'GET_ANY_PACKAGE_OF_OWN_ESTABLISHMENT',
  create_ownEst_package: 'CREATE_ANY_PACKAGE_OF_OWN_ESTABLISHMENT',
  update_ownEst_package: 'UPDATE_ANY_PACKAGE_OF_OWN_ESTABLISHMENT',

  // [STOCKS / INVENTORY]
  // - establishment (own)
  get_ownEst_inventory: 'GET_ANY_INVENTORY_OF_OWN_ESTABLISHMENT',
  update_ownEst_inventory_quantity: 'UPDATE_ANY_INVENTORY_QUANTITY_OF_OWN_ESTABLISHMENT',
  update_ownEst_inventory_yield: 'UPDATE_ANY_INVENTORY_YIELDING_OF_OWN_ESTABLISHMENT',
  activate_ownEst_inventory: 'ACTIVATE_ANY_INVENTORY_OF_OWN_ESTABLISHMENT',
  deactivate_ownEst_inventory: 'DEACTIVATE_ANY_INVENTORY_OF_OWN_ESTABLISHMENT',

  // [SEASONS]
  // - establishment (own)
  get_ownEst_season: 'GET_ANY_SEASON_OF_OWN_ESTABLISHMENT',
  create_ownEst_season: 'CREATE_ANY_SEASON_OF_OWN_ESTABLISHMENT',
  update_ownEst_season: 'UPDATE_ANY_SEASON_OF_OWN_ESTABLISHMENT',
  delete_ownEst_season: 'DELETE_ANY_SEASON_OF_OWN_ESTABLISHMENT',
};

export default SCOPE;
